var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "million-bit-demo"
    }
  }, [_c('div', {
    attrs: {
      "id": "close-demo"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.close()
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Back")])]), _vm._v(" "), _c('video', {
    attrs: {
      "src": "/static/mobile-demo-pfp.webm",
      "autoplay": "",
      "controls": ""
    }
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3227eda5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Demo.vue
// module id = S/ZD
// module chunks = 2